import { type Dispatch, type SetStateAction } from 'react'

import { type CoverageAuditLogsFilters } from 'components/brokers/coverage_audit_logs/CoverageAuditLogsTable'
import { Button } from 'slab'

type CoverageAuditLogsQuickFiltersProps = {
  filters: CoverageAuditLogsFilters
  setFilters: Dispatch<SetStateAction<CoverageAuditLogsFilters>>
}

const CoverageAuditLogsQuickFilters = ({
  filters,
  setFilters,
}: CoverageAuditLogsQuickFiltersProps) => {
  const hasUnknownReasonFilter = filters.reasons?.includes('unknown')
  const hasActiveFilters = !!(
    filters.reasons?.length ||
    filters.actions?.length ||
    filters.member_ids?.length ||
    filters.after_date ||
    filters.before_date
  )

  const setUnknownReasonFilter = () => {
    setFilters({
      ...filters,
      reasons: ['unknown'],
    })
  }

  const clearFilters = () => {
    setFilters({})
  }

  return (
    <div className='ml-1 flex items-center justify-start gap-2 flex-shrink-0 flex-wrap'>
      <div className='text-sm font-semibold min-w-16'>Quick filters</div>
      <Button
        variant={hasUnknownReasonFilter ? 'tertiary' : 'tertiary-deemphasized'}
        onClick={setUnknownReasonFilter}
      >
        Unknown Reason Changes
      </Button>

      {/* Show clear button if any filters are active */}
      {hasActiveFilters && (
        <Button
          variant='tertiary-deemphasized'
          onClick={clearFilters}
        >
          Clear All Filters
        </Button>
      )}
    </div>
  )
}

export default CoverageAuditLogsQuickFilters
